import { getRegexFormatValidationRule } from './regex-format-validation-rule';
const numericOnlyRegex = /^\d+$/i;
export const numericOnlyValidationRule = getRegexFormatValidationRule(numericOnlyRegex);
